module.exports = __webpack_public_path__ + "static/group-1ad1cefc285b77fb738b3e868672e3c1.png";